import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { color, size } from '../helpers/variables';
import { fontFamilyHeading, dynamicFontSize } from '../helpers/mixins';

export const LargeNavigationButtonBlock = {};

LargeNavigationButtonBlock.Container = styled.div`
  width: 100%;
  height: 20px;
  padding-bottom: 100%;
  position: relative;
  //margin-bottom: 10px;

  @media screen and (min-width: ${size.large}px) {
    padding-bottom: 135.62%;
  }
`;

LargeNavigationButtonBlock.Content = styled(Link)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  text-decoration: none;
  color: inherit;
  background-image: url("${props => props.image}");
  justify-content: center;
  align-items: center;
  background-size: cover;
  
  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${color.black};
    opacity: .25;
    z-index: 1;
    transition: opacity 250ms ease-out;
    
    ${LargeNavigationButtonBlock.Container}:hover & {
      opacity: .45;
    }
  }
`;

LargeNavigationButtonBlock.Title = styled.p`
  ${fontFamilyHeading};
  ${dynamicFontSize(24, 34, 320, 800)};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: ${color.white};
  z-index: 2;
  position: relative;
  display: block;
  width: 100%;
  padding-bottom: 0.16667em;

  &:before,
  &:after {
    position: absolute;
    left: 27px;
    right: 27px;
    content: '';
    display: inline-block;
    height: 1px;
    background-color: ${color.white};
  }

  &:before {
    top: -5px;
  }

  &:after {
    bottom: -5px;
  }

  @media screen and (min-width: 800px) {
    ${dynamicFontSize(22, 34, 800, 1200)};
  }
`;



// WEBPACK FOOTER //
// ./src/styles/blocks/LargeNavigationButtonBlock.js